// 语言包导出文件
import zhWorkflow from './zh/workflow.json';
import enWorkflow from './en/workflow.json';
import zhDesktop from './zh/desktop.json';
import enDesktop from './en/desktop.json';

// 语言包资源对象
export const resources = {
  zh: {
    workflow: zhWorkflow,
    desktop: zhDesktop,
  },
  en: {
    workflow: enWorkflow,
    desktop: enDesktop,
  },
} as const;
